export default "__VITE_ASSET__DfYHBbaQ__"